import { parsePhoneNumber } from "libphonenumber-js";
import { PhoneInputValue } from "ui/common/components/input/PhoneInput/PhoneInput.types";

export default function useParsePhoneNumber(phone?: string): PhoneInputValue | undefined {
    if (!phone) return undefined;
    try {
        const phoneNumber = parsePhoneNumber(phone);
        return [phoneNumber.countryCallingCode, phoneNumber.nationalNumber];
    } catch {
        return undefined;
    }
}
